import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSkiNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.358.656a1.125 1.125 0 011.98-.02L8 5.465 10.661.637a1.125 1.125 0 011.981.02l.41.78c.41.78.402 1.714-.022 2.487l-2.936 5.339 3.203 5.81a.625.625 0 01-.547.927H9.98a.625.625 0 01-.548-.324L8 13.071l-1.432 2.605c-.11.2-.32.324-.548.324H3.25a.625.625 0 01-.547-.927l3.203-5.81-2.936-5.34a2.625 2.625 0 01-.023-2.486zM6.317 5l-1.96-3.557-.303.576c-.215.409-.21.898.012 1.302L5 5.021V5zm.689 1.25h-1.33l1.375 2.5h1.333zm3.343 8.5h1.343L9.073 10H7.738zM6.62 10.56l-2.31 4.191H5.65l1.636-2.976zm2.76-2.592l.945-1.717h-1.33l-.28.509zm2.265-6.524L9.684 5H11v.02l.934-1.699c.223-.404.227-.893.012-1.302z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSkiNormalXsmall;
